import {Message} from '@weus/fuc-design';
// 警告弹窗
export function warning(message,duration){
  if(!duration){duration=1000};
  Message.warning({message,duration})
}
// 成功弹窗
export function success(message){
  Message.success({message})
}